import * as React from 'react';
import { useEffect, Fragment } from 'react';
import CurrentUser from 'auth/CurrentUser';

export type DriftAttributes = {
  endUser?: boolean;
  email?: string;
  firstName?: string;
  lastName?: string;
  liveChatEnabled?: boolean;
};

type Props = {
  attributes: DriftAttributes;
  appId: string;
  token: string | null | undefined;
  driftIdentifyId?: string;
};

/*
  This is a copy of: https://github.com/chardmd/react-drift/blob/master/src/Drift.jsx
  We can update Drift functionality here since the above repo is no longer being maintained
*/

const addMainScript = (appId: string) => {
  const scriptText = `!function() {
        var t = window.driftt = window.drift = window.driftt || [];
        if (!t.init) {
          if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
          t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on", "setUserAttributes" ],
          t.factory = function(e) {
            return function() {
              var n = Array.prototype.slice.call(arguments);
              return n.unshift(e), t.push(n), t;
            };
          }, t.methods.forEach(function(e) {
            t[e] = t.factory(e);
          }), t.load = function(t) {
            var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
            o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
            var i = document.getElementsByTagName("script")[0];
            i.parentNode.insertBefore(o, i);
          };
        }
      }();
      drift.SNIPPET_VERSION = '0.3.1';
      drift.load('${appId}');`;

  insertScript(scriptText);
};

const insertScript = (scriptText: string) => {
  const script = document.createElement('script');
  script.innerText = scriptText;
  script.async = true;
  document.body.appendChild(script);
};

const addAttributes = (
  attributes: DriftAttributes,
  driftIdentifyId?: string,
  token?: string | null
) => {
  let scriptText = '';

  if (driftIdentifyId) {
    let jwtText = token ? `, ${JSON.stringify({ userJwt: token })}` : '';

    scriptText = `
        var t = window.driftt = window.drift = window.driftt || [];
        drift.identify('${driftIdentifyId}', ${JSON.stringify(attributes)}${jwtText})
      `;
    insertScript(scriptText);
  } else {
    scriptText = `
        drift.on('ready', function() {
          drift.api.setUserAttributes(${JSON.stringify(attributes)})
        })
      `;
    insertScript(scriptText);
  }
};

export default function Drift({ attributes, appId, token, driftIdentifyId }: Props) {
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.drift) {
      addMainScript(appId);
      addAttributes(attributes, driftIdentifyId, token);
    }
  }, [attributes, appId, token, driftIdentifyId]);

  return <Fragment />;
}
